import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Wallet = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '24',
    style,
    strokeAsPrimary: true,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 24'
    >
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M17 5V2a1 1 0 0 0-1-1H3a2 2 0 0 0-2 2m0 0a2 2 0 0 0 2 2h15a1 1 0 0 1 1 1v4M1 3v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4m0-4h-3a2 2 0 0 0 0 4h3m0-4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1'
      />
    </svg>
  );
};
